/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Hub_GroupInputs */

const en_us2_community_hub_group = /** @type {(inputs: Community_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MyPocketGym`)
};

const pt_br2_community_hub_group = /** @type {(inputs: Community_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MyPocketGym`)
};

const es_419_community_hub_group = /** @type {(inputs: Community_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MyPocketGym`)
};

const pt_pt2_community_hub_group = /** @type {(inputs: Community_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MyPocketGym`)
};

const fr_fr2_community_hub_group = /** @type {(inputs: Community_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MyPocketGym`)
};

const de_de2_community_hub_group = /** @type {(inputs: Community_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MyPocketGym`)
};

const it_it2_community_hub_group = /** @type {(inputs: Community_Hub_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MyPocketGym`)
};

/**
* | output |
* | --- |
* | "MyPocketGym" |
*
* @param {Community_Hub_GroupInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_hub_group = /** @type {((inputs?: Community_Hub_GroupInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Hub_GroupInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_hub_group(inputs)
	if (locale === "es-419") return es_419_community_hub_group(inputs)
	if (locale === "pt-PT") return pt_pt2_community_hub_group(inputs)
	if (locale === "fr-FR") return fr_fr2_community_hub_group(inputs)
	if (locale === "de-DE") return de_de2_community_hub_group(inputs)
	if (locale === "it-IT") return it_it2_community_hub_group(inputs)
	return en_us2_community_hub_group(inputs)
});
export { community_hub_group as "community.hub_group" }